import routeConfiguration from '../routeConfiguration';
import { findRouteByRouteName } from './routes';

export const preloadPageForRoute = routeName => {
  if (!routeName) {
    return;
  }

  const route = findRouteByRouteName(routeName, routeConfiguration());
  const { component } = route;
  if (component && typeof component.preload === 'function') {
    component.preload();
  }
};
